/* Uitverkochte productkaarten volledig uitschakelen.
   CSS zet pointer-events uit; dit haalt ze ook uit de tab-volgorde,
   zodat je er met het toetsenbord niet in kunt belanden. */
(() => {
  const lock = (root = document) => {
    root.querySelectorAll('.product-card').forEach((card) => {
      if (!card.querySelector('.f-badge--soldout')) return;
      card.classList.add('is-soldout');
      card.setAttribute('aria-disabled', 'true');
      card.querySelectorAll('a, button, input, select, [tabindex]').forEach((el) => {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
        if ('disabled' in el) el.disabled = true;
      });
    });
  };

  const start = () => {
    lock();
    // collectiepagina's laden bij filteren nieuwe kaarten in
    new MutationObserver((muts) => {
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1) lock(n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();
})();

/* Topbalk op mobiel: de vier berichten passen niet naast elkaar, dus daar
   rouleren ze. Op desktop staan ze gewoon allemaal naast elkaar. */
(() => {
  const MOBILE = '(max-width: 749px)';
  const row = document.querySelector('.fs-ann--row .fs-ann__row');
  if (!row) return;

  const items = [...row.querySelectorAll('.fs-ann__rowitem')];
  if (items.length < 2) return;

  let timer = null;
  let i = 0;

  const step = () => {
    const cur = items[i];
    i = (i + 1) % items.length;
    cur.classList.remove('is-on');
    cur.classList.add('is-out');
    items[i].classList.add('is-on');
    setTimeout(() => cur.classList.remove('is-out'), 600);
  };

  const start = () => {
    if (timer) return;
    items.forEach((el, n) => el.classList.toggle('is-on', n === 0));
    i = 0;
    timer = setInterval(step, 3500);
  };

  const stop = () => {
    clearInterval(timer);
    timer = null;
    items.forEach((el) => el.classList.remove('is-on', 'is-out'));
  };

  const mq = window.matchMedia(MOBILE);
  const sync = () => (mq.matches ? start() : stop());
  sync();
  mq.addEventListener('change', sync);
})();

/* De footerlink wijst nog naar /pages/about terwijl de pagina op
   /pages/over-ons staat. Liquid kreeg het pad op een 404 niet te pakken,
   dus vangen we het hier op. Zodra de menulink in Shopify is rechtgezet
   mag dit blok weg. */
(() => {
  const pad = location.pathname.toLowerCase().replace(/\/+$/, '');
  if (pad === '/pages/about') {
    location.replace('/pages/over-ons');
  }
})();

/* Scroll-animaties. Elementen stijgen rustig op zodra ze in beeld komen.
   De verbergklasse wordt hier gezet, niet in de CSS — draait het script niet,
   dan blijft alles gewoon zichtbaar in plaats van onzichtbaar te blijven. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const doelen = [
    '.fs-head',
    '.fs-cat',
    '.fs-pcard',
    '.fs-split__inner',
    '.fs-stat',
    '.fs-usp__item',
    '.rich-text__wrapper',
  ];

  const els = [];
  doelen.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => {
      // wat al boven de vouw staat niet verbergen
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      el.classList.add('fs-reveal');
      els.push(el);
    });
  });
  if (!els.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      // lichte trapsgewijze vertraging binnen dezelfde rij
      const buren = [...(e.target.parentElement?.children || [])];
      const i = Math.max(0, buren.indexOf(e.target));
      e.target.style.transitionDelay = Math.min(i, 5) * 80 + 'ms';
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

  els.forEach((el) => io.observe(el));
})();

/* --------------------------------------------------------------------------
   Vangnet voor productfoto's die onzichtbaar bleven (.media-wrapper.loading).
   Het image-lazy-element van het thema wacht op een load-event. Bij doorklikken
   vanaf een collectie is de foto vaak al geladen voordat dat script start; het
   event komt dan nooit meer en de foto blijft op opacity 0 tot een refresh.
   Zodra er beelddata is (naturalWidth > 0) of het laden klaar is, tonen we hem.
   -------------------------------------------------------------------------- */
(() => {
  const settle = (img) => {
    if (!img || img.tagName !== 'IMG') return;
    const wrapper = img.closest('.media-wrapper');
    if (!wrapper || !wrapper.classList.contains('loading')) return;
    if (img.naturalWidth > 0 || img.complete) {
      wrapper.classList.remove('loading');
      wrapper.classList.add('loaded');
      img.classList.add('loaded');
    }
  };
  const sweep = () => {
    document.querySelectorAll('.media-wrapper.loading img').forEach(settle);
  };

  // Elke foto die (opnieuw) laadt of faalt: wrapper direct vrijgeven.
  document.addEventListener('load', (e) => settle(e.target), true);
  document.addEventListener('error', (e) => {
    const w = e.target && e.target.closest && e.target.closest('.media-wrapper.loading');
    if (w) w.classList.remove('loading');
  }, true);

  // Als het thema later alsnog 'loading' zet op een foto die al beelddata heeft.
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      const el = m.target;
      if (el.classList && el.classList.contains('media-wrapper') && el.classList.contains('loading')) {
        const img = el.querySelector('img');
        if (img) requestAnimationFrame(() => settle(img));
      }
    }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });

  document.addEventListener('DOMContentLoaded', sweep);
  window.addEventListener('pageshow', sweep);
  window.addEventListener('load', sweep);
  setTimeout(sweep, 1200);
  setTimeout(sweep, 3500);
})();

/* ---------- Leverstatus per maat ----------
   1. Stipjes op de maatknoppen: groen = ligt in de winkel, goud = op bestelling. Liquid kan de
      winkelvoorraad alleen per los opgevraagde variant lezen, daarom haalt dit per maat de sectie
      fs-variant-status op (eenmalig per variant, daarna uit het geheugen).
   2. Regel-eigenschap "Levering" gaat mee met elk productformulier, zodat winkelwagen, checkout en
      bestelling tonen of het uit de winkel komt of besteld wordt. Bron: het beschikbaarheidspaneel van
      hetzelfde formulier, of (plakbalk) de opgehaalde status van de gekozen variant. */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const pending = new Map();
  const resolved = new Map(); // variant-id -> "status|werkdagen|winkels|regeltekst"
  const TITLES = { winkel: 'Ligt in de winkel', bestelling: 'Op bestelling' };
  const WATCH = 'input[data-fs-variant], [data-fs-levering], form[id^="product-form-"]';

  const statusOf = (id) => {
    if (!pending.has(id)) {
      pending.set(
        id,
        fetch(`${root}variants/${id}/?section_id=fs-variant-status`, { credentials: 'same-origin' })
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => {
            const m = html.match(/data-fs-variant-status="([^"]*)"/);
            const txt = document.createElement('textarea');
            txt.innerHTML = m ? m[1] : '';
            resolved.set(id, txt.value);
            return txt.value;
          })
          .catch(() => '')
      );
    }
    return pending.get(id);
  };

  const decorate = () => {
    document.querySelectorAll('input[data-fs-variant]').forEach((input) => {
      const id = input.dataset.fsVariant;
      const label = input.id && document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (!id || !label || label.dataset.fsFor === id) return;
      label.dataset.fsFor = id;
      statusOf(id).then((full) => {
        const status = full.split('|')[0];
        if (label.dataset.fsFor !== id) return;
        if (TITLES[status]) {
          label.dataset.fsStatus = status;
          label.title = TITLES[status];
          const info = label.closest('product-info');
          if (info) info.classList.add('fs-dots-ready');
        } else {
          delete label.dataset.fsStatus;
          label.removeAttribute('title');
        }
      });
    });
  };

  const syncLevering = (form) => {
    // getAttribute: het formulier bevat een <input name="id">, waardoor form.id dat veld teruggeeft.
    const formId = form && form.getAttribute && form.getAttribute('id');
    if (!formId || !formId.startsWith('product-form-')) return;
    const panel = document.querySelector(`#Inventory-${CSS.escape(formId.slice('product-form-'.length))} [data-fs-levering]`);
    let value = '';
    if (panel) {
      value = panel.dataset.fsLevering;
    } else {
      const idField = form.querySelector('[name="id"]');
      const id = idField && idField.value;
      if (id && resolved.has(id)) {
        value = resolved.get(id).split('|')[3] || '';
      } else if (id) {
        statusOf(id).then(() => syncLevering(form));
      }
    }
    let input = form.querySelector('input[name="properties[Levering]"]');
    if (!value) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Levering]';
      form.appendChild(input);
    }
    input.value = value;
  };

  const refresh = () => {
    decorate();
    document.querySelectorAll('form[id^="product-form-"]').forEach(syncLevering);
  };

  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      refresh();
    });
  };

  document.addEventListener('submit', (e) => syncLevering(e.target), true);
  document.addEventListener('change', (e) => {
    if (e.target && e.target.closest && e.target.closest('form[id^="product-form-"]')) queue();
  });
  document.addEventListener('DOMContentLoaded', () => {
    refresh();
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1 && (node.matches(WATCH) || node.querySelector(WATCH))) {
            queue();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();

/* ---------- Zoeken binnen een filterlijst (bv. Merk) ----------
   Het veld hoort niet bij het filterformulier (form-attribuut naar een niet-bestaand formulier) en de
   events worden in de capture-fase afgevangen, zodat facets.js niet bij elke toets de filters herlaadt. */
(() => {
  const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  const apply = (input) => {
    const box = input.closest('.accordion-details__content') || input.parentElement.parentElement;
    const list = box && box.querySelector('ul');
    if (!list) return;
    const q = norm(input.value);
    let hits = 0;
    list.classList.toggle('fs-facet-searching', q !== '');
    list.querySelectorAll(':scope > li').forEach((li) => {
      const label = li.querySelector('label');
      const text = norm(label ? label.firstChild && label.firstChild.textContent || label.textContent : li.textContent);
      const match = q !== '' && text.includes(q);
      li.classList.toggle('fs-match', match);
      if (match) hits += 1;
    });
    const more = box.querySelector('show-more-button');
    if (more) more.hidden = q !== '';
    const leeg = box.querySelector('.fs-facet-search__leeg');
    if (leeg) leeg.hidden = q === '' || hits > 0;
  };
  ['input', 'change', 'keyup'].forEach((type) => {
    document.addEventListener(type, (e) => {
      if (!e.target.matches || !e.target.matches('[data-fs-facet-search]')) return;
      e.stopPropagation();
      if (type !== 'change') apply(e.target);
    }, true);
  });
  document.addEventListener('keydown', (e) => {
    if (e.target.matches && e.target.matches('[data-fs-facet-search]') && e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
